import React from 'react';
import type { Observable } from 'rxjs';
import { interval } from 'rxjs';

interface ContextValue {
  counter: Observable<number>;
}

const counter = interval(1000);

export const TimerProviderContext = React.createContext<ContextValue>({ counter });

const TimerProvider: React.FC = ({ children }) => (
  <TimerProviderContext.Provider value={{ counter }}>{children}</TimerProviderContext.Provider>
);

export default TimerProvider;
